// Client-side mirror of night pricing in backend/app/services/night_pricing.py (NIGHT_PRICED_SOURCES,
// night_increase_at). The server decides the price when a sale is recorded;
// this only makes the tiles show that same price, so what the caretaker reads
// out is what gets charged. Keep the two in sync.
import { minuteInWindow, parseTimeToMinutes, venueMinuteAndDay } from "./billing";
import { sourceOf } from "./cafeSources";

export const NIGHT_PRICED_SOURCES = ["cigarettes", "fridge"];

/** ₹ added per unit of `source` right now — 0 by day, for menu items, or when off. */
export function nightIncreaseAt(night, source, nowMs = Date.now()) {
  if (!night?.enabled || !NIGHT_PRICED_SOURCES.includes(source)) return 0;
  const start = parseTimeToMinutes(night.start);
  const end = parseTimeToMinutes(night.end);
  if (start === null || end === null) return 0;
  if (!minuteInWindow(venueMinuteAndDay(nowMs).minuteOfDay, start, end)) return 0;
  return Number(night.increases?.[source]) || 0;
}

/** What one unit of `item` costs at `nowMs`. */
export function priceNow(item, night, nowMs = Date.now()) {
  return (Number(item?.selling_price) || 0) + nightIncreaseAt(night, sourceOf(item), nowMs);
}

/** "06:00" -> "6:00 AM", for "night prices till 6:00 AM". */
export function formatClock(hhmm) {
  const minutes = parseTimeToMinutes(hhmm);
  if (minutes === null) return hhmm || "";
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${h % 12 || 12}:${String(m).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`;
}
